const defaultSettings = {
    sound: false,
    trainer: {
        speed: 2,
        time: 5,
        steps: 4,
        count: 1,
        difficulties: [0, 0, 0, 0, 0, 0],
        theme: 0
    },
    multi: {
        time: 15,
        difficulties: [0, 0, 0],
        num: 0,
        theme: 0
    },
    cards: {
        speed: 2,
        count: 1,
        difficult: 0
    }
};

export default defaultSettings;